import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-offer-check',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './offer-check.component.html',
  styleUrl: './offer-check.component.css',
})
export class OfferCheckComponent {
  header = input<string>();
  bold1 = input<string>();
  text1 = input<string>();
  link1 = input<string>();
  bold2 = input<string>();
  text2 = input<string>();
  link2 = input<string>();
}
